import {ProposalStatus} from '@prisma/client'

export {ProposalStatus}

export enum Role {
  Admin = 'admin',
  User = 'user',
  Librarian = 'librarian',
  Supplier = 'supplier',
}
export const ROLES = [Role.Admin, Role.Librarian, Role.Supplier, Role.User] as const
export const DEFAULT_ROLE = Role.User

export const PROPOSAL_STATUSES = Object.values(ProposalStatus)

export enum Action {
  Create = 'create',
  Read = 'read',
  Update = 'update',
  Delete = 'delete',
}
export const ACTIONS = [Action.Create, Action.Read, Action.Update, Action.Delete] as const

export enum Entity {
  Book = 'book',
  Proposal = 'proposal',
  Rental = 'rental',
  User = 'user',
  TextContent = 'textContent',
}
export const ENTITIES = [
  Entity.Book,
  Entity.Proposal,
  Entity.Rental,
  Entity.User,
  Entity.TextContent,
] as const

export enum Access {
  Own = 'own',
  Any = 'any',
}
export const ACCESSES = [Access.Own, Access.Any] as const

export enum EmailType {
  BookRented = 'book_rented',
  Feedback = 'feedback',
  ProposalApproved = 'proposal_approved',
  ProposalAvailable = 'proposal_available',
  ProposalInStock = 'proposal_in_stock',
  ProposalOrdered = 'proposal_ordered',
  ProposalRejected = 'proposal_rejected',
  ProposalSubmitted = 'proposal_submitted',
  RentalCreated = 'rental_created',
  RentalFirstReminder = 'rental_first_reminder',
  RentalReturned = 'rental_returned',
  RentalSecondReminder = 'rental_second_reminder',
  RentalThirdReminder = 'rental_third_reminder',
  Test = 'test',
}
